import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { SectionHeadline } from '$/components/core/Collection/SectionHeadline';
import { DashboardSectionRow } from '$/pages/DashboardPages/components/DashboardSectionRow';
import { InspirationRow } from '$/pages/DashboardPages/pages/Welcome/components/InspirationSection/components/InspirationRow';
import { useLastSeenStore } from '$/stores/useLastSeenStore';

export const InspirationSection = () => {
  const { t } = useTranslation();

  const lastSceneAmount = useLastSeenStore(
    useShallow((s) => s.lastScenes.length),
  );

  return (
    <SectionHeadline
      headline={
        lastSceneAmount > 0
          ? t('dashboard.welcome.inspirationText')
          : t('inspirationEditor.inspirations')
      }
      showAllUrl='/inspirations'
    >
      <DashboardSectionRow>
        <InspirationRow />
      </DashboardSectionRow>
    </SectionHeadline>
  );
};
